import { z } from 'zod/v4';

import { CIDTO, CILinkDTO } from '@/entities/srm/ci/@x/tql-query';
import { AdvancedTQLFilterDTO } from './advanced-filter';
import { TQLFilterDTO } from './query';

/** GraphRequestDTO */
export const TQLGraphRequestDTO = z.object({
  query: TQLFilterDTO,
  include: z.array(z.string()).optional(),
  advanced_tql_params: AdvancedTQLFilterDTO.optional(),
});

/** GraphCacheRequestDTO */
export const TQLGraphCachedRequestDTO = z.object({
  query_id: z.string(),
  // filter and include commented out, so not included here
});

/** GraphResponseDTO */
export const TQLGraphResponseDTO = z.object({
  nodes: z.array(CIDTO).nullish(),
  links: z.array(CILinkDTO).nullish(),
  cits: z.record(z.string(), z.array(z.string())).nullish(),
  cit_names: z.record(z.string(), z.string()).nullish(),
  count_cits: z.record(z.string(), z.number()).nullish(),
});

// If you want to derive TypeScript types from schemas:
export type TQLGraphRequest = z.infer<typeof TQLGraphRequestDTO>;
export type TQLGraphCachedRequest = z.infer<typeof TQLGraphCachedRequestDTO>;
export type TQLGraphResponse = z.infer<typeof TQLGraphResponseDTO>;